export default __webpack_public_path__ + "static/media/qr-screen-intro.fc584ceb.mp3";